import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { WidgetComponent } from '../../dashboards/components/widget-component/widget-component';``
import * as contactUsSelectors from '../selectors/contactus';
import { ContactUsModel } from '../models/contactus-model';
import { RouteContextService } from '../../context/services/route-context.service';
import { IContext } from '../../context/models/context';
import * as contactUsActions from '../actions/contactus';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'mojo-contactus-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './contactus-container.component.html',
})
export class ContactUsContainerComponent extends WidgetComponent {

  contactInfo$: Observable<ContactUsModel[]>;
  loading$: Observable<boolean>;
  error$: Observable<string>;
  context: IContext;

  constructor(
    protected readonly store: Store<any>,
    route: ActivatedRoute,
    private contextService: RouteContextService,
    protected confirmationService: ConfirmationService
  ) {
    super(store, confirmationService);
    this.context = this.contextService.getContextFromRoute(route);
    this.store.dispatch(new contactUsActions.Load(this.context));
  }

  ngOnInit() {
    this.error$ = this.store.pipe(select(contactUsSelectors.getError));
    this.loading$ = this.store.pipe(select(contactUsSelectors.getLoading));
    this.contactInfo$ = this.store.pipe(select(contactUsSelectors.getContactInfo(this.widget.widgetConfigId)));
  }

}
